import React from "react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { tools } from "../../data/content";
export function Toolkit() {
  return <section className="bg-white px-4 py-16 md:py-24" aria-labelledby="toolkit-title" data-id="element-282" data-mp="1yf4xzfu5prwx">
      <div className="mx-auto max-w-5xl" data-id="element-283" data-mp="1yhhj21v7oie7">
        <SectionHeading eyebrow="Also included" title={<span id="toolkit-title" data-id="element-285" data-mp="27ftcscrdjwav">The Complete Decision Toolkit</span>} subtitle="30+ practical tools you can use while you organize real cases." data-id="element-284" data-mp="23f9c4z7leajz" />

        <ul className="mt-10 grid gap-x-10 md:grid-cols-2" data-id="element-286" data-mp="2cd39mdh3fa8q">
          {tools.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 border-b border-sand py-5" data-id="element-287" data-mp="2h7z21eq8rzmd">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-50 text-brand-600" data-id="element-288" data-mp="2m3xrz6r7xpow">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-289" data-mp="2v5du6r7vqli1" />
              </span>
              <div data-id="element-290" data-mp="2v3b82i9ulcil">
                <h3 className="text-[17px] font-bold text-ink" data-id="element-291" data-mp="20wjr0kldlhh5">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-292" data-mp="20ugvjl1gew51">{text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-balance text-center font-serif text-2xl font-extrabold leading-snug text-ink md:text-3xl" data-id="element-293" data-mp="1qxkir34ivnuo">
          Any complex sensory case can feel <em className="text-brand-600" data-id="element-294" data-mp="2jn1h0hetpyyt">more organized</em> when you have a process to follow.
        </p>

        <div className="mt-8" data-id="element-295" data-mp="2eo87f02nqs3x">
          <CtaButton label="I want the complete system" data-id="element-296" data-mp="2eozsvi2jj9gh" />
        </div>
      </div>
    </section>;
}